import React from 'react';

import { INotificationGridItem } from '../notification-grid';

import { DetailsRow } from './DetailsRow';
import { LeadInfo } from './utils';

export const NewLeadDuplicateByPhoneDetails: React.FC<
  INotificationGridItem
> = ({ date, notificationDetails: { data } }) => {
  const message = `Client ID ${data.duplicateLeadId}, Name ${data.duplicateLeadFullName} is duplicate by phone of original Client ID ${data.originalLeadId}, Name ${data.originalLeadFullName}.`;

  return (
    <>
      <DetailsRow label="Date" value={date} />
      <DetailsRow label="Message" value={message} />
      <DetailsRow
        label="Duplicate client ID"
        component={<LeadInfo leadId={data.duplicateLeadId} />}
      />
      <DetailsRow
        label="Original client ID"
        component={<LeadInfo leadId={data.originalLeadId} />}
      />
    </>
  );
};
